export const PRICING_PLAN_NAMES = [
  'Individual Free',
  'Individual Lite',
  'Individual Pro',
  'Corporate',
  'Corporate Pro',
] as const;

export type PricingPlanName = typeof PRICING_PLAN_NAMES[number];

export const PRICING_PLAN_COUNT = PRICING_PLAN_NAMES.length;

export interface PricingTextSegment {
  text: string;
  colSpan: number;
  highlight?: boolean;
}

export interface PricingTextRow {
  kind: 'text';
  label: string;
  segments: PricingTextSegment[];
  bold?: boolean;
}

export interface PricingCheckRow {
  kind: 'check';
  label: string;
  included: boolean[];
  bold?: boolean;
}

export type PricingMatrixRow = PricingTextRow | PricingCheckRow;

export const PRICING_MATRIX_ROWS: PricingMatrixRow[] = [
  {
    kind: 'text',
    label: 'Ideal for',
    bold: true,
    segments: [
      { text: 'A single professional', colSpan: 2 },
      { text: 'Freelancer, startup, small biotech, agent, distributor', colSpan: 1 },
      { text: 'A small to medium pharma or biotech company', colSpan: 1 },
      { text: 'Large pharma or biotech company, trade association', colSpan: 1 },
    ],
  },
  {
    kind: 'text',
    label: 'Allowed users',
    bold: true,
    segments: [
      { text: '1', colSpan: 1 },
      { text: '1', colSpan: 1 },
      { text: '3', colSpan: 1 },
      { text: '6', colSpan: 1 },
      { text: '15', colSpan: 1 },
    ],
  },
  {
    kind: 'check',
    label: 'Profile',
    bold: true,
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Profile emailed to PDF',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Face Control connection',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Encrypted messaging',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Social feed',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Proprietary search bar',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Click & connect with real people',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Address Book',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'QR code',
    included: [true, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Showcase — Services',
    included: [false, true, true, true, true],
  },
  {
    kind: 'check',
    label: 'Showcase — Standard Products',
    included: [false, false, true, true, true],
  },
  {
    kind: 'check',
    label: 'Showcase — Custom Products',
    included: [false, false, true, true, true],
  },
  {
    kind: 'check',
    label: 'Attachments',
    included: [false, false, true, true, true],
  },
  {
    kind: 'check',
    label: 'Company admin account',
    included: [false, false, false, true, true],
  },
  {
    kind: 'check',
    label: 'Match-making events',
    included: [false, false, false, true, true],
  },
  {
    kind: 'check',
    label: 'Who has viewed me?',
    included: [false, false, false, true, true],
  },
  {
    kind: 'check',
    label: 'Followers',
    included: [false, false, false, true, true],
  },
  {
    kind: 'check',
    label: 'Dedicated support',
    included: [false, false, false, false, true],
  },
  {
    kind: 'text',
    label: 'Pricing',
    segments: [{ text: 'Free Trial 2026', colSpan: PRICING_PLAN_COUNT, highlight: true }],
  },
];
